import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReconciliationAndPayoutComponent } from './reconciliation-and-payout.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncButtonModule } from '../../../../shared/directives/async-button/async-button.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MainPipe } from '../../../../shared/pipes/pipes.module';
import { MatInputModule } from '@angular/material/input';
import { FlexModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../../../../shared/shared.module';
import { ProgressSpinnerModule } from '../../../../shared/progress-spinner-overlay/progress-spinner-overlay.module';
import { PayoutDisplayModule } from './payout-display/payout-display.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { ImageCarouselModule } from '../../../../shared/image-carousel/image-carousel.module';
import { HoldProcessingFailureDialogModule } from '../../../../shared/dialogs/hold-processing-failure-dialog/hold-processing-failure-dialog.module';

@NgModule({
  declarations: [ReconciliationAndPayoutComponent],
  exports: [ReconciliationAndPayoutComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FormsModule,
    AsyncButtonModule,
    MatButtonModule,
    MatIconModule,
    MainPipe,
    MatInputModule,
    FlexModule,
    MatCardModule,
    SharedModule,
    ProgressSpinnerModule,
    PayoutDisplayModule,
    MatTooltipModule,
    LoadingModule,
    ImageCarouselModule,
    HoldProcessingFailureDialogModule,
  ],
})
export class ReconciliationAndPayoutModule {}
